<template>
  <div>
    <van-popup v-model="offLine" round class="wanliu-van-popup">
      <div class="wanliu-wrapper">
        <div class="close" @click="offLine = false"></div>
        <div class="title">{{info.title}}</div>
        <div class="desc">
          <div class="line" v-for="(item, index) in info.desc" :key="index">
          {{item}}
         </div>
        </div>

        <div class="btn-group">
          <div @click="cancelHandler" class="rightbtn">{{info.btn}}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>

const Map = {
  0: {
    title: '很遗憾，活动已结束',
    desc: ['下次记得早点来哦！'],
    btn: '我知道了'
  },
  1: {
    title: '活动通知',
    desc: ['1.活动将于8月31日结束，请及时使用抽奖机会，逾期失效;', '2.活动结束后，您可通过“网校APP-我的-查快递”查看物流进度'],
    btn: '我知道了'
  },
  2: {
    title: '感谢您的参与，抽奖活动已结束！',
    desc: ['注：8月31日后，您可通过“网校APP-我的-查快递”查看物流进度'],
    btn: '我知道了'
  },
  3: {
    title: '活动通知',
    desc: ['1.您的分享截图正在审核中，审核通过后将增加1次抽奖机会;', '2.8月31日活动结束后，您可通过“网校APP-我的-查快递”查看物流进度'],
    btn: '我知道了'
  }
}

export default {
  name: '',
  props: {
    type: Number
  },
  watch: {
    type() {
      this.info = Map[this.type] || {}
    }
  },
  data() {
    return {
      info: {},
      offLine: false
    }
  },
  created() {
    this.info = Map[this.type] || {}
    console.log(this.info)
  },
  methods: {
    // 我知道了
    cancelHandler() {
      this.offLine = false
    }
  }
}
</script>
<style lang="less" scoped>
.wanliu-van-popup {
  overflow-y: unset !important;

  .wanliu-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 590px/2;
    height: 412px/2;
    padding: 40px/2 40px/2;
    text-align: center;
    background: #fff;
    border-radius: 10px;
  }

  .title {
    margin-top: 12px;
    font-size: 16px;
    font-weight: bold;
    color: #90402c;
  }

  .desc {
    margin-top: 16px;
    font-size: 12px;
    color: #666;
  }

  .btn-group {
    display: flex;
    width: 100%;
    height: 70px/2;
    margin-top: 44px/2;

    div {
      flex: 1;
      width: 50%;
      height: 35px;
      margin-right: 15px;
      font-size: 30px/2;
      font-weight: 400;
      line-height: 35px;
      text-align: center;
      border-radius: 35px/2;
    }

    .rightbtn {
      color: #fff;
      background: linear-gradient(-69deg, #e42225 0%, #ed4351 99%);
    }
  }
}
</style>
